// extracted by mini-css-extract-plugin
module.exports = {"paypalMessageShort":"az_KIb","paypalMessageTall":"az_LIb"};